__turbopack_context__.v({
  "btn": "MeVvgq_btn",
  "btnFooter": "MeVvgq_btnFooter",
  "cardArticle": "MeVvgq_cardArticle",
  "cards": "MeVvgq_cards",
  "content": "MeVvgq_content",
  "custom-dot-list-style": "MeVvgq_custom-dot-list-style",
  "headContact": "MeVvgq_headContact",
  "headkutip": "MeVvgq_headkutip",
  "newtitle": "MeVvgq_newtitle",
  "p": "MeVvgq_p",
  "page-body-wrap": "MeVvgq_page-body-wrap",
  "pagehero": "MeVvgq_pagehero",
  "paragraph": "MeVvgq_paragraph",
  "paragraph-content": "MeVvgq_paragraph-content",
  "phonecontent": "MeVvgq_phonecontent",
  "react-multi-carousel-dot": "MeVvgq_react-multi-carousel-dot",
  "react-multi-carousel-dot--active": "MeVvgq_react-multi-carousel-dot--active",
  "react-multi-carousel-list": "MeVvgq_react-multi-carousel-list",
  "slider": "MeVvgq_slider",
  "store": "MeVvgq_store",
  "t": "MeVvgq_t",
  "title": "MeVvgq_title",
  "wrap-container": "MeVvgq_wrap-container",
  "wrap-content": "MeVvgq_wrap-content",
});
